import React from 'react';
import { DatePicker, ConfigProvider } from 'antd';
import koKR from 'antd/locale/ko_KR';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';

dayjs.locale('ko');

/**
 * 연-월 선택 (브라우저/OS locale 무관, 항상 한국어 패널)
 * value: Date | dayjs | 'YYYY-MM' | null
 * onChange: (yyyyMm: string) => void  — 항상 'YYYY-MM' 문자열
 */
const MonthPicker = ({
  value,
  onChange,
  className = '',
  disabled = false,
  allowClear = false,
  size = 'small',
}) => {
  const parsed = (() => {
    if (value == null || value === '') return null;
    if (typeof value === 'string') {
      const d = dayjs(value, 'YYYY-MM', true);
      return d.isValid() ? d : null;
    }
    const d = dayjs(value);
    return d.isValid() ? d : null;
  })();

  return (
    <ConfigProvider locale={koKR}>
      <DatePicker
        picker="month"
        size={size}
        allowClear={allowClear}
        inputReadOnly
        disabled={disabled}
        format="YYYY-MM"
        value={parsed}
        onChange={(d) => onChange(d ? d.format('YYYY-MM') : '')}
        className={className || 'w-[162px]'}
      />
    </ConfigProvider>
  );
};

export default MonthPicker;
